import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import AreaLookup from 'src/lookups/item-organizacao';
import './GerarCopiaControlada.css';
import { capitalizeFirstLetter } from 'src/utils/string';
import Input from 'src/componentes/input';
import Button from 'src/componentes/button';
import ContentManager from 'src/componentes/content-manager';
import Alert from 'src/componentes/message-box/alert';
import { DownloadFile } from 'src/services/downloadFileUrl';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import LoadingContainer from 'src/componentes/loading-container';

function GerarCopiaControlada({
  handleClose,
  onSuccess,
  quantidadePermitidaCopias,
  arquivo,
  urlCustom,
  convertWordToPdf,
  parameters,
}) {
  const resources = useSelector((state) => state.user.termos);
  const intl = useIntl();
  const [filtroDefault, setFiltroDefault] = useState({});
  const [quantidadeErro, setQuantidadeErro] = useState(null);
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const hasErrorField = (field) => errors.includes(field);

  const handleChangeFiltro = (field, value) => {
    setFiltroDefault((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => prev.filter((e) => e !== field));
  };

  const handleChangeQuantidade = (value) => {
    handleChangeFiltro('quantidade', value);
    if (
      quantidadePermitidaCopias != null &&
      quantidadePermitidaCopias !== '' &&
      Number(value) > Number(quantidadePermitidaCopias)
    ) {
      setQuantidadeErro(
        `${intl.formatMessage({
          id: 'labelQuantidadeMaximaCopiasControladas',
        })}: ${quantidadePermitidaCopias} ${intl.formatMessage({
          id: 'labelCopias',
        })}`
      );
    } else {
      setQuantidadeErro(null);
    }
  };

  const validateRequiredFields = () => {
    const erros = [];
    !filtroDefault.area && erros.push('area');
    const qty = Number(filtroDefault.quantidade);
    (!Number.isFinite(qty) || qty < 1) && erros.push('quantidade');
    !filtroDefault.justificativa && erros.push('justificativa');
    return erros;
  };

  const handleGerarCopia = async () => {
    const erros = validateRequiredFields();
    if (erros.length > 0 || quantidadeErro) {
      setErrors(erros);
      ContentManager.addContent(
        <Alert
          message={intl.formatMessage({
            id: 'label.osCamposDestacadosEmVermelhoSaoObrigatoriosFavorPreenchelos',
          })}
        />
      );
      return;
    }

    try {
      setIsLoading(true);
      const response = await http.post(
        urlCustom || 'DocumentoDownload/DownloadFile',
        {
          fileName: arquivo?.nome,
          convertWordToPdf,
          ...parameters,
          isDownload: true,
          copiaControlada: true,
          areaId: filtroDefault.area?.id,
          fileId: arquivo?.id,
          quantidadeCopias: Number(filtroDefault.quantidade),
          justificativa: filtroDefault.justificativa,
        },
        { responseType: 'blob' }
      );
      DownloadFile(response, null);
      onSuccess && onSuccess(Number(filtroDefault.quantidade));
      handleClose();
    } catch (error) {
      if (error.response?.data instanceof Blob) {
        const text = await error.response.data.text();
        error.response.data = JSON.parse(text);
      }
      errorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoadingContainer isLoading={isLoading}>
      <label className="gerar-copia-controlada_description">
        {capitalizeFirstLetter(
          intl.formatMessage({ id: 'labelDescricaoCopiaControlada' })
        )}
      </label>
      <div className="mt-2 mb-5">
        <AreaLookup
          clearable
          required
          model={{
            label: capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'labelAreaDestino' },
                { area: resources?.area }
              )
            ),
            value: filtroDefault.area,
            requestChange: (value) => handleChangeFiltro('area', value),
            errors: hasErrorField('area'),
          }}
        ></AreaLookup>
        <Input
          type="number"
          min={1}
          required
          model={{
            label: intl.formatMessage({ id: 'labelQuantidadeCopias' }),
            value: filtroDefault.quantidade ?? 0,
            requestChange: handleChangeQuantidade,
            errors: quantidadeErro || hasErrorField('quantidade'),
            erros: quantidadeErro || undefined,
          }}
        />
        <Input
          type="textarea"
          style={{ height: 100 }}
          min={1}
          required
          maxLength={300}
          placeholder={intl.formatMessage({
            id: 'labelDigiteAlgo',
          })}
          model={{
            label: intl.formatMessage({
              id: 'labelJustificativaFinalidadeCopia',
            }),
            value: filtroDefault.justificativa ?? '',
            requestChange: (value) =>
              handleChangeFiltro('justificativa', value),
            errors: hasErrorField('justificativa'),
          }}
        />
      </div>
      <hr style={{ marginLeft: -15, marginRight: -15 }} />
      <div className="gerar-copia-controlada_footer mb-3 mt-3">
        <Button
          onClick={handleClose}
          color="link"
          style={{ color: '#0D7E94', fontWeight: '600' }}
        >
          {intl.formatMessage({ id: 'label.cancelar' })}
        </Button>
        <Button onClick={handleGerarCopia}>
          {intl.formatMessage({ id: 'labelGerarCopia' })}
        </Button>
      </div>
    </LoadingContainer>
  );
}

export default GerarCopiaControlada;
